var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNexticon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53427 0.434759L9.88394 7.78446C10.4636 8.36414 10.4636 9.30426 9.88394 9.8825L2.53427 17.2322C1.95459 17.8119 1.01444 17.8119 0.434759 17.2322C-0.14492 16.6525 -0.14492 15.7123 0.434759 15.1327L6.734 8.83348L0.434759 2.53427C-0.14492 1.95459 -0.14492 1.01444 0.434759 0.434759C1.01444 -0.14492 1.95459 -0.14492 2.53427 0.434759Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexticon);
export default __webpack_public_path__ + "static/media/nexticon.c0f8197bbeb4286ab515657d9b848c5b.svg";
export { ForwardRef as ReactComponent };